import axios from "axios";

function runtimeConfig() {
  try {
    return window.__AW_RUNTIME_CONFIG__ || {};
  } catch {
    return {};
  }
}

export const api = axios.create({
  baseURL: runtimeConfig().apiBaseUrl || process.env.REACT_APP_API_BASE_URL || "",
});

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common.Authorization;
  }
}


